import Select from 'react-select'
import {connect} from 'react-redux'
import {FormGroup, ControlLabel, FormControl} from 'react-bootstrap'
import React, {Component} from 'react'
import {actions, Errors} from 'react-redux-form'
import _ from 'lodash'
import hash from 'object-hash'
import PropTypes from 'prop-types';

import 'react-select/dist/react-select.css'
import '../multi-select.css'

class RequiredMultiSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value:   [],
      options: []
    };

    if (props.model) {
      props.dispatch(actions.setValidity(props.model, false));
    }
  }

  componentWillReceiveProps(nextProps) {
    let {options, value} = this.state;
    const {model, dispatch} = this.props;

    if (this.props.withAllOption && nextProps.data.length) {
      nextProps.data.unshift({ label: 'All', value: 'all' });
    }

    const transformedOptions = this.renderOptions(nextProps.data);
    let transformedValue = this.renderOptions(nextProps.value);

    if (hash(options, {excludeValues: true}) !== hash(transformedOptions, {excludeValues: true}) ||
      hash(value, {excludeValues: true}) !== hash(transformedValue, {excludeValues: true})) {

      if (value.length) {
        transformedValue = value;
      } else if (transformedOptions.length) {
        transformedValue = transformedOptions.filter(val => transformedValue.find(otherVal => val.value == otherVal.value));
      }

      this.setState({
        options: transformedOptions,
        value:   transformedValue
      });

      if (model) {
        dispatch(actions.change(model, transformedValue));
        dispatch(actions.setValidity(model, transformedValue.length));
        dispatch(actions.setErrors(model, {
          required: !transformedValue.length
        }));
      }
    }
  }

  componentDidMount() {
    const {value, data} = this.props;
    this.componentWillReceiveProps({value: value, data: data});
  }

  handleChange(val) {
    const {model, dispatch} = this.props;

    if (this.props.withAllOption && val.some(item => item.value === "all")) {
      val = val.filter(item => item.value === "all");
    }

    this.setState({value: val}, () => {
      if (!val.length && model) {
        dispatch(actions.change(model, []));
        dispatch(actions.setValidity(model, false));
        dispatch(actions.setErrors(model, {
          required: true
        }));

      }
      else if (model) {
        dispatch(actions.change(model, val));
        dispatch(actions.setValidity(model, true));
        dispatch(actions.setErrors(model, {
          required: false
        }));
      }

      if (this.props.onChange && this.props.onChange !== undefined) {
        this.props.onChange(val);
      }
    });
  }

  renderOptions = (values) => {
    const {valueAttr, labelAttr} = this.props;
    if (_.isPlainObject(values)) {
      return (
        Object.keys(values).map(item => {
          return ({label: values[item], value: item})
        })
      )
    } else {
      return (
        values.map(item => {
          if (_.isPlainObject(item)) {
            if (item.hasOwnProperty('label') && item.hasOwnProperty('value')) {
              return item;
            }
            return ({label: _.get(item, labelAttr), value: _.get(item, valueAttr)})
          } else {
            return ({label: item, value: item})
          }
        })
      )
    }
  };

  renderArrow = ({onMouseDown, isOpen}) => {
    if (isOpen) {
      return (
        <i className="fa fa-angle-up"/>
      )
    } else {
      return (
        <i className="fa fa-angle-down"/>
      );
    }

  };

  render() {
    return (
      <FormGroup className="multiselect-formgroup"
                 controlId={this.props.controlId}
                 validationState={this.state.value.length > 0 ? null : "error"}>
        {this.props.label && <ControlLabel>{this.props.label}*</ControlLabel>}
        <Select placeholder={this.props.placeholder}
                className="form-control"
                value={this.state.value}
                options={this.state.options}
                arrowRenderer={this.renderArrow}
                clearable={false}
                cache={false}
                autoBlur
                disabled={this.props.disabled}
                closeOnSelect
                onChange={(option) => this.handleChange(option)}
                multi={true}
                searchable={this.props.searchable}/>

        <Errors
          show={true}
          className="errors"
          model={this.props.model}
          messages={this.props.messages || {required: 'This field is required'}}/>
      </FormGroup>
    )
  }
}

RequiredMultiSelect.propTypes = {
  model:          PropTypes.string,
  label:          PropTypes.string,
  data:           PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object]).isRequired,
  labelAttr:      PropTypes.string,
  valueAttr:      PropTypes.string,
  controlId:      PropTypes.string,
  placeholder:    PropTypes.string,
  searchable:     PropTypes.bool,
  disabled:       PropTypes.any,
  withAllOption:  PropTypes.bool
};

RequiredMultiSelect.defaultProps = {
  labelAttr:      'label',
  valueAttr:      'value',
  controlId:      Math.random().toString(16).substring(2),
  searchable:     true,
  withAllOption:  false
};

export default connect()(RequiredMultiSelect);


// WEBPACK FOOTER //
// ./src/components/common/form/elements/required-multi-select.jsx